<template>
  <div class="trading-page">
    <!-- <PreloaderPage /> -->
    <BannerPages
      class="banner-big"
      :title="'trading.banner.title1'"
      :descriptions="[
        $t('trading.banner.subTitle1'),
        $t('trading.banner.subTitle2')
      ]"
      :img="'/images/trading/banner-2.png'"
      mainImageWidthDesk="1152"
      mainImageHeightDesk="740"
      alt="Monitoring stocks on laptop and phone"
      :buttons="[
        {
          type: 'external',
          href: getExternalUrl('/register/1/live-account'),
          class: 'primary-button-medium',
          text: 'home.banner.button-1' 
        },
        {
          type: 'external',
          href: getExternalUrl('/register/1/demo-account'),
          class: 'second-button-medium-white',
          text: 'home.banner.button-2' 
        }
      ]"
    />
    <LazyExperienceDiff
      :title="$t('trading.experience.title')"
      :subTitle="$t('trading.experience.subTitle')"
    />
    <LazyBuildPortafolioVue :style="degrade"/>
    <LazyTradingGoals />
    <LazyNeedOurAccount :style="degrade2"/>
    <client-only>
      <LazyInvestment
        :label="'trading.investment.title'"
        :buttonConfigs="[
          {
            type: 'external',
            href: getExternalUrl('/register/1/live-account'),
            class: 'primary-button-medium',
            textKey: 'investment.link'
          }
        ]"
      />
    </client-only>
  </div>
</template>

<script setup>
import LazyExperienceDiff from "~/components/home/ExperienceDiff.vue";
import LazyBuildPortafolioVue from "~/components/trading/BuildPortafolio.vue";
import LazyTradingGoals from "~/components/trading/TradingGoals.vue";
import LazyNeedOurAccount from "~/components/trading/NeedOurAccount.vue";
// import PreloaderPage from "~/components/PreloaderPage.vue";
import { useI18n } from "vue-i18n";
import { useExternalUrl } from '@/composables/useExternalUrl';
import { useImage } from '#imports'; 

const { getExternalUrl } = useExternalUrl();
const { t } = useI18n();

const nuxtImg = useImage();

const title = t("seo.trading.title");
const description = t("seo.trading.description");
const imgSeo = 'https://tradeview.eu/images/seo/02Trading.jpg'

useSeoMeta({
  title: title,
  ogTitle: title,
  twitterTitle: title,
  description: description,
  ogDescription: description,
  twitterDescription: description,
  ogImage: imgSeo,
  twitterImage: imgSeo
});

const degradadeImageUrl = '/images/trading/Trading-Gradient.avif';
const degradadeImageUrl2 = '/images/trading/Trading-Gradient2.avif';

const optimizedDegrade = nuxtImg(degradadeImageUrl, {
  quality: 50,
  format: 'avif',
});
const optimizedDegrade2 = nuxtImg(degradadeImageUrl2, {
  quality: 50,
  format: 'avif',
});

const degrade = computed(() => {
  return {
    '--degrade': `url('${optimizedDegrade}')`,
  };
});

const degrade2 = computed(() => {
  return {
    '--degrade2': `url('${optimizedDegrade2}')`,
  };
});
</script>
